import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';
import { BinaryEntityRaw } from '@edgvr-front/binaries/domain';
import { BinariesActions } from '../actions';

export interface LatestState extends EntityState<BinaryEntityRaw> {
  isLoading: boolean;
}

export const latestAdapter: EntityAdapter<BinaryEntityRaw> =
  createEntityAdapter<BinaryEntityRaw>({
    selectId: (_) => _.instance,
    sortComparer: (lhs, rhs) =>
      lhs.instance.localeCompare(rhs.instance, undefined, {
        sensitivity: 'base',
      }),
  });

export const initialLatestState: LatestState = latestAdapter.getInitialState({
  isLoading: false,
});

const reducer = createReducer(
  initialLatestState,
  on(BinariesActions.listLatest, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(BinariesActions.listLatestSuccess, (state, { binaries }) =>
    latestAdapter.setAll(
      binaries.map((_) => _.value),
      {
        ...state,
        isLoading: false,
      }
    )
  ),
  on(BinariesActions.listLatestFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(BinariesActions.binaryBatchItemCreateSuccess, (state, { binary }) =>
    latestAdapter.upsertOne(binary.value, state)
  )
);

export function latestReducer(state: LatestState | undefined, action: Action) {
  return reducer(state, action);
}
